/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Scenario } from '@scenario/models/scenario.model';
import { RootState } from '../../create-store';
import { UnitRate } from '@scenario/models/unit-rate.model';

export interface ExportSelectedScenariosState {
  scenarios: Scenario[];
  isExporting: boolean;
  error?: string;
}

const initialState: ExportSelectedScenariosState = {
  scenarios: [],
  isExporting: false,
};

export const exportSelectedScenariosSlice = createSlice({
  name: 'exportSelectedScenarios',
  initialState,
  reducers: {
    exportSelectedScenarios: (state, _action: PayloadAction<{ scenarios: Scenario[],
      rawScenarios: Scenario[], unitRates: UnitRate[] }>) => {
      state.isExporting = true;
      state.scenarios = [];
    },
    exportSelectedScenariosSuccess: (state, action: PayloadAction<Scenario[]>) => {
      state.isExporting = false;
      state.scenarios = action.payload;
    },
  },
});

export type ExportedScenariosViewModel = {
  scenarios: Scenario[];
  isExporting: boolean;
  error?: string;
};

export const selectExportedScenariosViewModel = createSelector(
  (state: RootState) => state,
  (state): ExportedScenariosViewModel => ({
    scenarios: state.selectedScenariosExported.scenarios,
    isExporting: state.selectedScenariosExported.isExporting,
    error: state.selectedScenariosExported.error,
  }),
);

export const { exportSelectedScenarios, exportSelectedScenariosSuccess } =
  exportSelectedScenariosSlice.actions;

export default exportSelectedScenariosSlice.reducer;
